module.exports = __webpack_public_path__ + "img/typelist4.cf0e979f.svg";